"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatus = exports.TaskType = void 0;
var TaskType;
(function (TaskType) {
    TaskType["delete"] = "delete";
    TaskType["zip_assets"] = "zip_assets";
    TaskType["send_email"] = "send_email";
    TaskType["refund_payment"] = "refund_payment";
    TaskType["process_referral"] = "process_referral";
    TaskType["create_ots_qr_codes"] = "create_ots_qr_codes";
})(TaskType = exports.TaskType || (exports.TaskType = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["failed"] = "failed";
    TaskStatus["pending"] = "pending";
    TaskStatus["running"] = "running";
    TaskStatus["completed"] = "completed";
    TaskStatus["terminated"] = "terminated";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
